import { Link } from '@farol-ds/react'
import { COMPONENT_NAME, SELECTED_OPTION } from '@jusbrasil-web/shared-ga4-events'
import { sendMetrics } from '@jusbrasil-web/shared-utils-events'
import { formatDate } from '@jusbrasil-web/shared-utils-format'
import { useEffect } from 'react'

import emailImgSrc from '../../../assets/cpf-validation/email.svg'
import { CLICK_EVENT_PROPS, COMPONENT_RENDER_EVENT_PROPS, GA4EventHandlers } from '../../../hooks'
import { SUPPORT_CONTACT_URL } from '../constants'
import { useIdDocumentValidationContext } from '../context'
import { DocumentStaticStep } from './document-static-step'

interface RemovalCpfEmailProps {
  onClose?: () => void
  gA4EventHandlers?: GA4EventHandlers
}

export function RemovalCpfEmail(props: RemovalCpfEmailProps) {
  const { onClose, gA4EventHandlers } = props
  const { sharedData, viewer, eventData } = useIdDocumentValidationContext()

  const old_user_id = sharedData?.profileInUse?.pid?.toString() ?? ''

  const stepEvent = (event: string, metadata: Record<string, string>) => {
    const pid = viewer?.pid.toString() || null

    sendMetrics(event, pid, {
      ...eventData,
      metadata: {
        cpf: sharedData?.cpf,
        birthDate: formatDate(sharedData?.birthDate?.getTime() || ''),
        old_user_id,
        ...eventData?.metadata,
        ...metadata,
      },
    })
  }

  useEffect(() => {
    gA4EventHandlers?.sendComponentRender({
      componentClass: null,
      componentName: COMPONENT_NAME.IDENTITY_ALREADY_VERIFIED,
      renders: COMPONENT_RENDER_EVENT_PROPS.REMOVAL_CPF_EMAIL,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <DocumentStaticStep
      testId="removal-cpf-email-step"
      imageSrc={emailImgSrc}
      title="E-mail de verificação enviado"
      bodyText={
        <>
          Acesse o e-mail que enviamos para <strong>{sharedData?.profileInUse?.email}</strong> para
          cadastrar o CPF à conta atual.
        </>
      }
      bodyText2={
        <>
          Entre em{' '}
          <Link
            href={SUPPORT_CONTACT_URL}
            target="_blank"
            onClick={() => {
              stepEvent('UserAccount.IdValidationChangeAccountSubmitted', {
                button: 'SupportHelp',
              })
              gA4EventHandlers?.sendClick({
                ...CLICK_EVENT_PROPS.REMOVAL_CPF_EMAIL,
                selectedOption: SELECTED_OPTION.CONTACT_SUPPORT,
              })
            }}
          >
            contato com nosso suporte
          </Link>{' '}
          caso não reconheça este e-mail.
        </>
      }
      action={{
        onClick: () => {
          stepEvent('UserAccount.IdValidationChangeAccountSubmitted', { button: 'Finish' })
          gA4EventHandlers?.sendClick({
            ...CLICK_EVENT_PROPS.REMOVAL_CPF_EMAIL,
            selectedOption: SELECTED_OPTION.COMPLETE,
          })
          onClose?.()
        },
        label: 'Concluir',
      }}
      onLoadEvent={{
        name: 'UserAccount.IdValidationChangeAccountViewed',
        metadata: { old_user_id },
      }}
    />
  )
}
